import React, { FC, useContext } from 'react';
import DataBox from '../DataBox';
import icon_electricSupply from '../../../../../imgs/icon-electricSupply.png';
import icon_load from '../../../../../imgs/icon-load.png';
import styles from './index.module.scss';
import icon_small_ground from '../../../../../imgs/icon-small-ground.png';
import { V2MicrogridOverviewGetNewEnergyRatePostResponse } from '@maxtropy/intelligent-dispath-apis-v2';
import { formatPower, judgeOverZero, keepTwoOrLine, keepTwoOrLineAbs } from '@/pages/IndustrialGreenMicBigScreen/utils';
import { ShareDataContext } from '@/pages/IndustrialGreenMicBigScreen';

export interface ITwoAssetsRender {
  data?: V2MicrogridOverviewGetNewEnergyRatePostResponse;
}

const TwoAssetsRender: FC<ITwoAssetsRender> = props => {
  const { data } = props;
  const { isFullScreen } = useContext(ShareDataContext);

  return (
    <>
      {/* 源数据 */}
      <DataBox
        top={12}
        left={5}
        leftTitle={'网'}
        data={[
          {
            label: '今日上网电量',
            value: keepTwoOrLine(data?.gridInfo?.feedIn),
            unit: 'kWh',
            color: '#16DD8E',
          },
          {
            label: '今日下网电量',
            value: formatPower(data?.gridInfo?.purchased).value,
            unit: formatPower(data?.gridInfo?.purchased).unit,
            color: '#00ADFF',
          },
        ]}
      />
      {/* 图片 */}
      <div className={`${styles.element1} ${styles.element}`} style={{ top: isFullScreen ? '20%' : '16%' }}>
        <img className={styles.img_obj_sty} src={icon_electricSupply} alt="" />
        <img className={styles.img_normal_sty} src={icon_small_ground} alt="" />
        <div className={styles.label}>{'市电'}</div>
      </div>
      {/* 流动的线1 */}
      <div className={`${styles.lineBg1} ${styles.lineBg_normal}`}>
        {/* 线上面数据 */}
        <div className={styles.line_data}>
          <div className={styles.label}>{judgeOverZero(data?.gridInfo?.power) ? '净下网' : '上网'}功率:</div>
          <div className={styles.value}>{keepTwoOrLineAbs(data?.gridInfo?.power)}kW</div>
        </div>
        <div
          className={`${styles.line_inside_normal} ${styles.line1} ${
            styles[judgeOverZero(data?.gridInfo?.power) ? 'flow_left' : 'flow_right']
          }`}
        ></div>
      </div>

      {/* 源数据 */}
      <DataBox
        top={12}
        left={75}
        leftTitle={'荷'}
        data={[
          {
            label: '今日用电量',
            value: formatPower(data?.loadInfo?.todayConsumption).value,
            unit: formatPower(data?.loadInfo?.todayConsumption).unit,
            color: '#16DD8E',
          },
        ]}
      />
      <div className={`${styles.element2} ${styles.element}`} style={{ top: isFullScreen ? '20%' : '16%' }}>
        <img className={styles.img_obj_sty} src={icon_load} alt="" />
        <img className={`${styles.img_normal_sty} `} src={icon_small_ground} alt="" />
        <div className={styles.label}>{'负载'}</div>
      </div>
      {/* 流动的线2 */}
      <div className={`${styles.lineBg2} ${styles.lineBg_normal}`}>
        {/* 线上面数据 */}
        <div className={styles.line_data}>
          <div className={styles.label}>用电负荷:</div>
          <div className={styles.value}>{keepTwoOrLine(data?.loadInfo?.powerDemand)}kW</div>
        </div>
        <div className={`${styles.line_inside_normal} ${styles.line2} ${styles.flow_left}`}></div>
      </div>
    </>
  );
};

export default TwoAssetsRender;
